
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import RelatedLinks from '../components/RelatedLinks';
import { SITE_URL } from '../lib/site';
// Evergreen facts, so no data fetching. The comparison rows and FAQ are driven
// off key lists to keep the markup and the FAQPage JSON-LD in sync.
const OPTION_KEYS = ['metro', 'train', 'taxi', 'bus'];
const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4'];
function CphToCopenhagen() {
    const { t, lang } = useTranslation('cph-to-copenhagen');
    const url = lang === 'en'
        ? `${SITE_URL}/en/cph-to-copenhagen`
        : `${SITE_URL}/cph-to-copenhagen`;
    const faqs = FAQ_KEYS.map((k, i) => ({ q: t(k), a: t(`a${i + 1}`) }));
    const faqJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map(({ q, a }) => ({
            '@type': 'Question',
            name: q,
            acceptedAnswer: { '@type': 'Answer', text: a }
        }))
    };
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('meta_title')}</title>
                <meta name="description" content={t('meta_description')}/>
                <meta name="robots" content="all"/>
                <link rel="canonical" href={url}/>
                <meta property="og:title" content={t('meta_title')}/>
                <meta property="og:description" content={t('meta_description')}/>
                <meta property="og:url" content={url}/>
                <script type="application/ld+json" 
    // static/trusted content; escape < so no </script> break-out
    dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqJsonLd).replace(/</g, '\\u003c')
        }}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">{t('page_title')}</h1>
            <p className="mt-3 text-gray-600">{t('intro')}</p>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('compare_title')}</h2>
                <div className="mt-3 overflow-x-auto">
                    <table className="w-full text-left text-sm border-collapse">
                        <thead>
                            <tr className="border-b border-gray-300 *:py-2 *:pr-4 *:font-semibold">
                                <th>{t('col_option')}</th>
                                <th>{t('col_time')}</th>
                                <th>{t('col_frequency')}</th>
                                <th>{t('col_price')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {OPTION_KEYS.map((k) => (<tr key={k} className="border-b border-gray-100 align-top *:py-3 *:pr-4">
                                    <td className="font-medium">
                                        {t(`opt_${k}`)}
                                    </td>
                                    <td>{t(`opt_${k}_time`)}</td>
                                    <td>{t(`opt_${k}_freq`)}</td>
                                    <td>{t(`opt_${k}_price`)}</td>
                                </tr>))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('pick_title')}</h2>
                <ul className="mt-2 list-disc list-inside text-gray-700 *:my-1">
                    <li>{t('pick_fastest')}</li>
                    <li>{t('pick_cheapest')}</li>
                    <li>{t('pick_easiest')}</li>
                </ul>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('ticket_title')}</h2>
                <p className="mt-2 text-gray-700">{t('ticket_note')}</p>
                <p className="mt-2 text-gray-700">{t('station_note')}</p>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('faq_title')}</h2>
                <dl className="mt-4 divide-y divide-gray-200">
                    {faqs.map(({ q, a }, i) => (<div key={i} className="py-4">
                            <dt className="text-lg font-semibold text-gray-900">
                                {q}
                            </dt>
                            <dd className="mt-2 text-gray-700">{a}</dd>
                        </div>))}
                </dl>
            </section>

            <RelatedLinks links={[
            { href: '/trains', labelKey: 'link_trains' },
            { href: '/passport-control', labelKey: 'link_passport' },
            { href: '/parking', labelKey: 'link_parking' }
        ]}/>
        </div>);
}
export default CphToCopenhagen;

    async function __Next_Translate__getStaticProps__1a1723ec60f__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cph-to-copenhagen',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec60f__ as getStaticProps }
  